import React, { useRef, useEffect, useCallback } from 'react';
import styled from '@emotion/styled';
import { darken, rgba, lighten } from 'polished';

import { blue } from '~/theseus/styles/core';

const selectColor = darken(0.05, '#1AB7EA');

const borderRadius = '4px';

const ItemInner = styled.li`
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px ${rgba('#000', 0.1)}, 0 0px ${rgba('#000', 0.025)};
  background: #fff;
  transition: box-shadow 100ms ease;

  &[aria-selected="true"] {
    box-shadow: inset 0 0 0 5px ${selectColor};

    &:after {
      content: "Selected";
      position: absolute;
      top: 0;
      right: 0;
      padding: 4px 8px;
      color: #fff;
      background: ${selectColor};
      border-bottom-left-radius: ${borderRadius};
      border-top-right-radius: ${borderRadius};
    }
  }

  &[aria-selected="false"] {
    &:after {
      left: 0;
      right: 0;
      padding-top: 8px;
      color: ${rgba('#000', 0.5)};
    }

    &:hover,
    &:focus {
      box-shadow: 0 0 0 1px ${rgba('#000', 0.1)},
        0 0 8px 4px ${lighten(0.2, blue)};
      transition: box-shadow 100ms ease;

      &:after {
        color: ${blue};
      }
    }
  }
`;

function Item(props) {
  const {
    id,
    selectItem,
    isSelected,
    gridId,
    className,
    scrollTo,
    children,
  } = props;

  const itemRef = useRef(null);

  const handleSelect = useCallback(() => selectItem(id), [selectItem, id]);
  useEffect(() => {
    if (isSelected && itemRef.current) {
      itemRef.current.focus();
      scrollTo(itemRef.current.offsetTop - 10);
    }
  }, [isSelected]);

  return (
    <ItemInner
      ref={itemRef}
      id={`${gridId}-${id}`}
      role="option"
      aria-selected={isSelected}
      onClick={handleSelect}
      className={className}
    >
      {children}
    </ItemInner>
  );
}

export default React.memo(Item);
